function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import moment from "moment-timezone";
import { postUser } from "../actions";
export var TimeZoneContext = /*#__PURE__*/React.createContext({});
export var TimeZoneProvider = function TimeZoneProvider(_ref) {
  var children = _ref.children;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var postUserCall = useSelector(function (state) {
    return state.apiCalls.postUser["undefined"];
  }) || {};
  var _useCookies = useCookies(["pref-timeZone"]),
    _useCookies2 = _slicedToArray(_useCookies, 3),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1],
    removeCookie = _useCookies2[2];
  var _useState = useState(authUser && authUser.lastTimeZone || cookies["pref-timeZone"] || {
      name: moment.tz.guess()
    }),
    _useState2 = _slicedToArray(_useState, 2),
    timeZone = _useState2[0],
    setTimeZone = _useState2[1];
  useEffect(function () {
    removeCookie("pref-timeZone");
    setCookie("pref-timeZone", timeZone);
    moment.tz.setDefault(timeZone.name);
    if (authUser && JSON.stringify(authUser.lastTimeZone) !== JSON.stringify(timeZone)) {
      authUser.lastTimeZoneName = timeZone;
      dispatch(postUser(authUser));
    }
  }, [timeZone]);
  useEffect(function () {
    if (!authUser) return;
    if (!authUser.lastTimeZone) {
      authUser.lastTimeZoneName = moment.tz.guess();
      dispatch(postUser(authUser));
    } else {
      setTimeZone(authUser.lastTimeZone);
    }
  }, [authUser]);
  return /*#__PURE__*/React.createElement(TimeZoneContext.Provider, {
    value: {
      timeZone: timeZone,
      setTimeZone: setTimeZone,
      loading: postUserCall.isFetching
    }
  }, children);
};
export var useTimeZoneContext = function useTimeZoneContext() {
  return useContext(TimeZoneContext);
};